import { storeToRefs } from 'pinia';
import { complementarySidebarStore } from '~/stores/complementarySidebar';

export default function () {

  const store = complementarySidebarStore();
  const { isComplementarySidebarOpen } = storeToRefs(store);

  return {
    ...store,
    isComplementarySidebarOpen,
  };

}